// removed by extract-text-webpack-plugin
module.exports = {"label":"src-components-Expandable----styles-module---label---2HD3B","content":"src-components-Expandable----styles-module---content---B3wUC","open":"src-components-Expandable----styles-module---open---1p16d","icon":"src-components-Expandable----styles-module---icon---1QQrh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Expandable/styles.module.css
// module id = 499
// module chunks = 168707334958949